<template>
    <div class="d-row">
        <TileCard class="tile-card" :loaded="teamsStore.isLoaded">
            <template #body>
                <ServiceTeamTable :data="teamsStore.getServiceTeams" @detail="displayTeamDetail"></ServiceTeamTable>                
            </template>
            <template #footer>
                <div class="buttons">
                    <Button class="accent" @click="onCreateTeamClick">
                        <b>+</b>Create Team
                    </Button>
                </div>
            </template>
        </TileCard>
        <TileCard class="tile-card">
            <template #body>
                <ServiceTeam v-if="props.team" :team="props.team" :changed="props.teamChange" @reload="reload">
            </ServiceTeam>
            </template>
        </TileCard>    
    </div>
    <CreateTeamModal :team="props.newTeam" :modal-id="createTeamModalId" @close="closeCreateTeam" @create="onCreateNewTeam">

    </CreateTeamModal>
</template>

<script lang="ts" setup>
import TileCard from '@/components/util/TileCard.vue';
import ServiceTeamTable from '@/components/service_teams/ServiceTeamTable.vue';
import ServiceTeam from '@/components/service_teams/ServiceTeam.vue';
import { useServiceTeamsStore } from "@/stores/serviceTeams";
import { reactive, onMounted, ref } from 'vue';
import { ServiceTeamItem } from '@/services/entities/ServiceTeams/ServiceTeamItem';
import CreateTeamModal from '@/components/service_teams/dialogs/CreateTeamModal.vue'
import { ServiceItem } from '@/services/entities/ServiceItem';
import { useVfm } from "vue-final-modal";

const createTeamModalId = Symbol("createTeamModalId");
const vfm = useVfm();
const teamsStore = useServiceTeamsStore();
const props = reactive({
    team: null as  ServiceTeamItem | null,
    newTeam: {service: { } as ServiceItem } as  ServiceTeamItem,
    teamChange: false,
});

onMounted(async () => {
    console.log(props.team);
    await teamsStore.loadServiceTeams();
});

function displayTeamDetail(teamId: string) {
    teamsStore.getServiceTeams.forEach(team => {
        if (team.id === teamId) {
            props.team = team;
        }
    });    
}

async function onCreateNewTeam() {
    console.log(props.newTeam);
    vfm.close(createTeamModalId);
    teamsStore.createServiceTeam(props.newTeam);
    await teamsStore.loadServiceTeams();    
}

function closeCreateTeam() {
    vfm.close(createTeamModalId);
}

async function reload(teamId: string) {
    props.team = null;
    await teamsStore.loadServiceTeams();
}

function onCreateTeamClick() {
    console.log("clickin for new");
    vfm.open(createTeamModalId);
}
</script>

<style lang="scss" scoped>
.tile-card {
    overflow: auto;
    height: calc(100vh - 240px);
}
</style>